export default {
  // 查询测站雨量累计值
  GET_ACCUMULATE_RAIN: 'GET_ACCUMULATE_RAIN',
  // 查询实时水情数据
  GET_LATEST_WATER_LEVEL1: 'GET_LATEST_WATER_LEVEL1',
  // 查询实时水情中对应stid水库72小时数据
  GET_RAINWATER_MINUTES_TOTAL: 'GET_RAINWATER_MINUTES_TOTAL',
  // 获得图层控制数据
  GET_LAYERCONTROL_DATA: 'GET_LAYERCONTROL_DATA',
  // 预警信息
  // GET_EARLY_WARNING_LIST: 'GET_EARLY_WARNING_LIST',
  // 获取雨情/水位数据
  GET_YURUN_DATA: 'GET_YURUN_DATA',
  // 获获取水利工程单个站点详情数据
  GET_ITEM_DATA: 'GET_ITEM_DATA',
  // 获取水系面信息
  GET_RIVER_GEOM_LIST: 'GET_RIVER_GEOM_LIST',
  // 获取降雨等值面信息
  GET_RAIN_GRAPH: 'GET_RAIN_GRAPH'
}
